import { HITS_PER_PAGE } from "../index";

export default function useQueryVariables({ location }) {
  const variables = {};
  if (location) {
    const { after, sort } = location.query;
    variables.first = HITS_PER_PAGE;
    variables.after = after;
    variables.sort = sort;
  }

  return {
    variables,
    hitsPerPage: HITS_PER_PAGE
  };
}
